import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";

export default function Faq() {
  const [faq, setFaq] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  let isMounted = true;
  const controller = new AbortController();

    window.scrollTo(0, 0);
    axios.get("api/home/faq",  { signal: controller.signal }).then((res) => {
      if (!isMounted) return;
      if (res.data.status == "success") {
        setFaq(res.data.data);
      } else {
        setFaq([]);
      }
      setLoading(false);
    }).catch(error => {
      if (!isMounted) return;
      if (error.name !== "AbortError" && error.name !== "CanceledError") {
        console.error("Failed to load FAQ data:", error);
      }
    });

    return () => {
      isMounted = false;
      setFaq([]);
      controller.abort();
    };
  }, []);
  return (
    <div className="section-full p-t120  p-b90 site-bg-light">
      {/* <div className="container">
        <div className="row">
          <div className="col-12">
            <div id="accordion" role="tablist">
              {faq.length > 0
                ? faq.map((item) => {
                    let faqs = item.category_data;
                    return (
                      <React.Fragment>
                        <h4>{item.name}</h4>
                        {faqs.length > 0
                          ? faqs.map((faqitem, idx) => {
                              let faq_id = "faq_" + idx;
                              let acc_id = "collapse" + idx;
                              return (
                                <div className="single-faq">
                                  <div
                                    className="faq-heading"
                                    role="tab"
                                    id={faq_id}
                                  >
                                    <h4 className="faq-title">
                                      <a
                                        data-toggle="collapse"
                                        href={"#" + acc_id}
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                      >
                                        <i className="fa fa-caret-right" />
                                        {faqitem.question}
                                      </a>
                                    </h4>
                                  </div>
                                  <div
                                    id={acc_id}
                                    className={
                                      idx == 0 ? "collapse show" : "collapse"
                                    }
                                    role="tabpanel"
                                    aria-labelledby={faq_id}
                                    data-parent="#accordion"
                                  >
                                    <div className="faq-body">
                                      {ReactHtmlParser(faqitem.answer)}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : null}
                      </React.Fragment>
                    );
                  })
                : ""}
            </div>
          </div>
        </div>
      </div> */}

      <div className="container">
        <div className="tw-faq-section">
          <div className="accordion tw-faq" id="sf-faq-accordion">
            {faq.length > 0
              ? faq.map((faqitem, idx) => (
                  <div className="accordion-item">
                    <button
                      className={`accordion-button ${
                        idx == 0 ? "" : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      aria-expanded={` ${idx == 0 ? "true" : "false"}`}
                      data-bs-target={`#FAQ${idx}`}
                    >
                      {faqitem.title}
                    </button>

                    <div
                      id={`FAQ${idx}`}
                      className={`accordion-collapse collapse ${
                        idx == 0 ? "show" : ""
                      }`}
                      data-bs-parent="#sf-faq-accordion"
                    >
                      <div className="accordion-body">
                        {ReactHtmlParser(faqitem.description)}
                      </div>
                    </div>
                  </div>
                ))
              : ""}
            {/* <div className="accordion-item">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#FAQ2"
                aria-expanded="false"
              >
                What Makes Your Business Plans So Special?
              </button>

              <div
                id="FAQ2"
                className="accordion-collapse collapse"
                data-bs-parent="#sf-faq-accordion"
              >
                <div className="accordion-body">
                  A digital interface the person causing the movement of goods
                  uploads the relevant information prior to the commencement of
                  movement of goods and generates e-way bill on the GST portal.
                  Best service are provide us. simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy.
                </div>
              </div>
            </div> */}

            {/* <div className="accordion-item">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#FAQ3"
                aria-expanded="false"
              >
                Reset Password With Phone Number?
              </button>

              <div
                id="FAQ3"
                className="accordion-collapse collapse"
                data-bs-parent="#sf-faq-accordion"
              >
                <div className="accordion-body">
                  A digital interface the person causing the movement of goods
                  uploads the relevant information prior to the commencement of
                  movement of goods and generates e-way bill on the GST portal.
                  Best service are provide us. simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#FAQ4"
                aria-expanded="false"
              >
                How do I redeem a coupon?
              </button>

              <div
                id="FAQ4"
                className="accordion-collapse collapse"
                data-bs-parent="#sf-faq-accordion"
              >
                <div className="accordion-body">
                  A digital interface the person causing the movement of goods
                  uploads the relevant information prior to the commencement of
                  movement of goods and generates e-way bill on the GST portal.
                  Best service are provide us. simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#FAQ5"
                aria-expanded="false"
              >
                How long will it take to post my job?
              </button>

              <div
                id="FAQ5"
                className="accordion-collapse collapse"
                data-bs-parent="#sf-faq-accordion"
              >
                <div className="accordion-body">
                  A digital interface the person causing the movement of goods
                  uploads the relevant information prior to the commencement of
                  movement of goods and generates e-way bill on the GST portal.
                  Best service are provide us. simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#FAQ6"
                aria-expanded="false"
              >
                What is your cancellation policy?
              </button>

              <div
                id="FAQ6"
                className="accordion-collapse collapse"
                data-bs-parent="#sf-faq-accordion"
              >
                <div className="accordion-body">
                  A digital interface the person causing the movement of goods
                  uploads the relevant information prior to the commencement of
                  movement of goods and generates e-way bill on the GST portal.
                  Best service are provide us. simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#FAQ7"
                aria-expanded="false"
              >
                Where Can I Find Market Research Reports?
              </button>

              <div
                id="FAQ7"
                className="accordion-collapse collapse"
                data-bs-parent="#sf-faq-accordion"
              >
                <div className="accordion-body">
                  A digital interface the person causing the movement of goods
                  uploads the relevant information prior to the commencement of
                  movement of goods and generates e-way bill on the GST portal.
                  Best service are provide us. simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#FAQ8"
                aria-expanded="false"
              >
                Do I need to know PHP to use TheJobs?
              </button>

              <div
                id="FAQ8"
                className="accordion-collapse collapse"
                data-bs-parent="#sf-faq-accordion"
              >
                <div className="accordion-body">
                  A digital interface the person causing the movement of goods
                  uploads the relevant information prior to the commencement of
                  movement of goods and generates e-way bill on the GST portal.
                  Best service are provide us. simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#FAQ9"
                aria-expanded="false"
              >
                How soon will I start receiving resumes?
              </button>

              <div
                id="FAQ9"
                className="accordion-collapse collapse"
                data-bs-parent="#sf-faq-accordion"
              >
                <div className="accordion-body">
                  A digital interface the person causing the movement of goods
                  uploads the relevant information prior to the commencement of
                  movement of goods and generates e-way bill on the GST portal.
                  Best service are provide us. simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy.
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
